import React, { useEffect, useState } from 'react'
import { useAuth } from '../../modules/auth'
import { setupAxios } from '../../modules/auth';
//import { getTodayAttendanceSummary } from '../../../api/AttendanceAPI'
import { getAttendanceRecords } from '../../../api/AttendanceAPI'
import { getAttendanceSummary } from '../../../api/AttendanceAPI';
import { getEmploymentTypes } from '../../../api/EmploymentType';
import { getDepartments } from '../../../api/DepartmentAPI';
import { getDashboardSummary } from '../../../api/AttendanceAPI'
import axios from 'axios';
import {
  getLeaveEmails,
  handleLeaveApproves,
  handleLeaveRejects,
} from '../../../api/LeaveAPI'

interface Department {
id: string
name: string
}
// 🔹 Convert "HH:mm" → minutes
const toMinutes = (duration?: string) => {
  if (!duration || !duration.includes(':')) return 0
  const [h, m] = duration.split(':').map(Number)
  return h * 60 + m
}

// 🔹 Convert minutes → HH:mm
const toHHMM = (mins: number) => {
  const h = Math.floor(mins / 60)
  const m = mins % 60
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`
}

// 🔹 Get first & last date of selected month
const getMonthRange = (month: string) => {
  const [y, m] = month.split('-').map(Number)
  const start = `${month}-01`
  const end = new Date(y, m, 0).toISOString().split('T')[0]
  return { start, end }
}

const AttendanceDashboard = () => {
  const [counts, setCounts] = useState({
    present: 0,
    absent: 0,
    late: 0,
    onLeave: 0,
    weeklyOff: 0,
    total: 0,
  })

  const [loading, setLoading] = useState(false)
  //const [pendingApprovals, setPendingApprovals] = useState(0)
  const [dailyAttendance, setDailyAttendance] = useState<any[]>([])
const [monthlyAttendance, setMonthlyAttendance] = useState<any[]>([])

  

  useEffect(() => {
  loadCounts()
}, [])
const [refreshTrigger, setRefreshTrigger] = useState(0)
const refreshDashboard = () => {
  setRefreshTrigger(prev => prev + 1)
}

const weeklyOffDays = [0, 6] // Sunday=0, Saturday=6
const loadCounts = async () => {
  try {
    const res = await getAttendanceSummary({
      startDate: new Date().toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0],
    })
    console.log("TODAY SUMMARY API 👉", res)

    if (res?.statusCode === 200) {
      setCounts(res.data.counts)   // 🔥 THIS LINE WAS MISSING
    }
// check if today is weekly off
    //   const weeklyOffToday = weeklyOffDays.includes(new Date().getDay()) ? 1 : 0

    // if (res?.statusCode === 200) {
    //   setCounts({...res.data.counts, weeklyOff: weeklyOffToday,})
    // }
  } catch (err) {
    console.error(err)
  }
}

const { currentUser } = useAuth()
const [attendanceData, setAttendanceData] = useState<any[]>([])
const [filteredData, setFilteredData] = useState<any[]>([])
const [department, setDepartment] = useState('')
const [fromDate, setFromDate] = useState('')
const [toDate, setToDate] = useState('')
// useEffect(() => {
//   loadAttendance()
// }, [fromDate, toDate])
const loadAttendance = async () => {
  try {
    const res = await getAttendanceRecords({
      startDate: fromDate || undefined,
      endDate: toDate || undefined,
    })

    if (res?.statusCode === 200) {
      const records =res?.data?.data?.records ?? []
        // Array.isArray(res.data)
        //   ? res.data
        //   : Array.isArray(res.data?.records)
        //   ? res.data.records
        //   : Array.isArray(res.data?.items)
        //   ? res.data.items
        //   : []

      setAttendanceData(records)
      setFilteredData(records)
    }
  } catch (err) {
    console.error(err)
    setAttendanceData([])
    setFilteredData([])
  }
}

type MonthlyLeaveSummary = {
  empCode: string
  empName: string
  EL: number
  CL: number
  SL: number
  unpaid: number
  compEarned: number
  compAvailed: number
  departmentId?: string
  employeeType?: string
  startDate?: string
  endDate?: string
}

type MonthlyCombinedSummary = {
  empCode: string
  empName: string

  EL: number
  CL: number
  SL:number
  unpaid: number
  compEarned: number
  compAvailed: number

  lateDays: number
  totalLateMinutes: number
  earlyOutDays: number
  totalEarlyOutMinutes: number

  departmentId?: string
  employeeType?: string
}

const [monthlyLeaveData, setMonthlyLeaveData] = useState<MonthlyLeaveSummary[]>([])
const [leaveLoading, setLeaveLoading] = useState(false)
// useEffect(() => {
//   loadMonthlyLeaveSummary()
// }, [currentUser])

// const loadMonthlyLeaveSummary = async () => {
//   if (!currentUser?.id) return

//   setLeaveLoading(true)

//   try {
//     const response = await getLeaveEmails(currentUser.id, 'receiver')

//     // 🔐 SAFETY CHECK
//     if (response?.statusCode !== 200 || !Array.isArray(response.data)) {
//       setMonthlyLeaveData([])
//       return
//     }

//     const leaves = response.data

//     const currentMonth = new Date().getMonth()
//     const currentYear = new Date().getFullYear()

//     const grouped: Record<string, MonthlyLeaveSummary> = {}

//     leaves.forEach((leave: any) => {
//       if (leave.status !== 'APPROVED') return

//       const startDate = new Date(leave.startDate)
//       if (
//         startDate.getMonth() !== currentMonth ||
//         startDate.getFullYear() !== currentYear
//       )
//         return

//       const empCode =
//   leave.user?.employeeCode ??
//   leave.sender?.employeeCode ??
//   //leave.userId
//   'UNKNOWN'

// // const empName =
// //   leave.user?.name ??
// //   leave.sender?.name ??
// //   '-'
// const empName =
//   leave.user
//     ? `${leave.user.firstName ?? ''} ${leave.user.lastName ?? ''}`
//     : leave.sender
//     ? `${leave.sender.firstName ?? ''} ${leave.sender.lastName ?? ''}`
//     : '-'


//       if (!grouped[empCode]) {
//         grouped[empCode] = {
//           empCode,
//           empName,
//           EL: 0,
//           CL: 0,
//           SL: 0,
//           unpaid: 0,
//           compEarned: 0,
//           compAvailed: 0,
//           departmentId:
//   leave.user?.departmentId ??
//   leave.sender?.departmentId ??
//   '',

// employeeType:
//   leave.user?.employeeType ??
//   leave.sender?.employeeType ??
//   '',

//     startDate: leave.startDate,
//     endDate: leave.endDate,
//         }
//       }

//       const days =
//         leave.leaveDuration === 'FULL'
//           ? 1
//           : 0.5

//       //switch (leave.leaveType?.code) 
//       switch (leave.leaveType?.name)
// {
//         case 'EL':
//           grouped[empCode].EL += days
//           break
//         case 'CL':
//           grouped[empCode].CL += days
//           break
//         case 'SL':
//           grouped[empCode].SL += days
//           break
//         case 'UNPAID':
//           grouped[empCode].unpaid += days
//           break
//         case 'COMP_EARNED':
//           grouped[empCode].compEarned += days
//           break
//         case 'COMP_AVAILED':
//           grouped[empCode].compAvailed += days
//           break
//       }
//     })

//     setMonthlyLeaveData(Object.values(grouped))
//   } catch (error) {
//     console.error('Monthly Leave Summary Error', error)
//     setMonthlyLeaveData([])
//   } finally {
//     setLeaveLoading(false)
//   }
// }

const [pendingApprovals, setPendingApprovals] = useState<any[]>([])
const [pendingCount, setPendingCount] = useState(0)
const [loadingPending, setLoadingPending] = useState(false)

useEffect(() => {
  loadPendingApprovals()
}, [currentUser])

// const approveLeave = async (leaveId: string) => {
//   await handleLeaveApproves(leaveId, currentUser)
//   loadPendingApprovals() // refresh
// }

// const rejectLeave = async (leaveId: string) => {
//   await handleLeaveRejects(leaveId, currentUser)
//   loadPendingApprovals() // refresh
// }
const approveLeave = async (leaveId: string) => {
  await handleLeaveApproves(leaveId, currentUser)
  refreshDashboard()
}

const rejectLeave = async (leaveId: string) => {
  await handleLeaveRejects(leaveId, currentUser)
  refreshDashboard()
}

const handleApproval = async (id: string, action: 'approve' | 'reject') => {
  if (action === 'approve') {
    await approveLeave(id)
  } else {
    await rejectLeave(id)
  }
}

const loadPendingApprovals = async () => {
  if (!currentUser?.id) return

  setLoadingPending(true)

  try {
    // const { id: currentUserId } = setupAxios(); // logged-in user ID
    // const action = "receiver"; // we want the leaves where this user is the receiver

    const res = await getLeaveEmails(currentUser.id, 'receiver')

    if (res?.statusCode === 200 && Array.isArray(res.data)) {
      const seenRequestIds = new Set<string>()
      const pending = res.data.filter((item: any) => {
        if (!item || item.status !== 'PENDING') return false

        const rawId = item.id
        const requestId = typeof rawId === 'string' || typeof rawId === 'number'
          ? String(rawId).trim()
          : ''
        if (!requestId || seenRequestIds.has(requestId)) return false

        seenRequestIds.add(requestId)
        return true
      })

      setPendingApprovals(pending)
      setPendingCount(pending.length)
    } else {
      setPendingApprovals([])
      setPendingCount(0)
    }
  } catch (error) {
    console.error('Pending approvals error', error)
    setPendingApprovals([])
    setPendingCount(0)
  } finally {
    setLoadingPending(false)
  }
}

  const [employeeType, setEmployeeType] = useState("");
  const [departments, setDepartments] = useState([]);
  //const [employeeTypes, setEmployeeTypes] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState<string[]>([]);


  
useEffect(() => {
  // Fetch departments
  const fetchDepartments = async () => {
    try {
      const res = await getDepartments(); // call the API service
      const depts = Array.isArray(res?.data) ? res.data : res?.data?.data ?? [];
      setDepartments(depts);
    } catch (err) {
      console.error('Failed to fetch departments:', err);
      setDepartments([]);
    }
  };

  // Fetch employment types from EmploymentType API
  const fetchEmployeeTypes = async () => {
    try {
      const res = await getEmploymentTypes(); // your API call

      // Assuming API returns { data: [...] } structure
      const types = Array.isArray(res?.data)
        ? res.data.map((et: { name: string }) => et.name)
        : [];

      setEmployeeTypes(types);
    } catch (err) {
      console.error("Failed to fetch Employment Types:", err);
      setEmployeeTypes([]);
    }
  };

  fetchDepartments();
  fetchEmployeeTypes();
}, []);



useEffect(() => {
  let filtered = [...monthlyAttendance];

  if (department) filtered = filtered.filter(i => i.departmentId === department);
  if (employeeType) filtered = filtered.filter(i => i.employeeType === employeeType);

  setFilteredData(filtered);
}, [department, employeeType, monthlyAttendance]);



const filteredMonthlyLeaveData = monthlyLeaveData.filter(item => {
  let match = true

  if (department) {
    match = match && item.departmentId === department
  }

  if (employeeType) {
    match = match && item.employeeType === employeeType
  }

  if (fromDate) {
    match = match && new Date(item.startDate!) >= new Date(fromDate)
  }

  if (toDate) {
    match = match && new Date(item.endDate!) <= new Date(toDate)
  }

  return match
})
// ===============================
// MERGE ATTENDANCE + LEAVE DATA
// ===============================
// const attendanceMap = new Map<string, any>()

// attendanceData.forEach(att => {
//   if (!att.employeeCode) return

//   attendanceMap.set(att.employeeCode, {
//     lateDays: att.lateDays ?? 0,
//     totalLateMinutes: att.totalLateMinutes ?? 0,
//     earlyOutDays: att.earlyOutDays ?? 0,
//     totalEarlyOutMinutes: att.totalEarlyOutMinutes ?? 0,
//   })
// })

// const combinedMonthlyData: MonthlyCombinedSummary[] =
//   filteredMonthlyLeaveData.map(leave => {
//     const attendance = attendanceMap.get(leave.empCode) || {}

//     return {
//       empCode: leave.empCode,
//       empName: leave.empName,

//       EL: leave.EL,
//       CL: leave.CL,
//       unpaid: leave.unpaid,
//       compEarned: leave.compEarned,
//       compAvailed: leave.compAvailed,

//       lateDays: attendance.lateDays,
//       totalLateMinutes: attendance.totalLateMinutes,
//       earlyOutDays: attendance.earlyOutDays,
//       totalEarlyOutMinutes: attendance.totalEarlyOutMinutes,

//       departmentId: leave.departmentId,
//       employeeType: leave.employeeType,
//     }
//   })

// =======================================================================
const leaveGrouped: Record<string, MonthlyLeaveSummary> = {}
const leaveTypeMap: Record<string, keyof MonthlyLeaveSummary> = {
  'Earned Leave': 'EL',
  'Casual Leave': 'CL',
  'Short Leave': 'SL', 
  'Unpaid Leave': 'unpaid',
  'Leave without Pay': 'unpaid',
  'Comp Off Earned': 'compEarned',
  'Comp Off Availed': 'compAvailed',
  'Compensatory Off': 'compAvailed',
}

monthlyLeaveData.forEach((leave: any) => {
  const empCode = leave.user?.employeeCode
  if (!empCode) return

  if (!leaveGrouped[empCode]) {
    leaveGrouped[empCode] = {
      empCode,
      empName: `${leave.user.firstName} ${leave.user.lastName}`,
      EL: 0,
      CL: 0,
      SL: 0,
      unpaid: 0,
      //compEarned: 0,
      compEarned: leave.compEarned ?? 0,
      compAvailed: 0,
      departmentId: leave.user?.departmentId ?? '',
      employeeType:
        leave.user?.employment?.[0]?.employmentType?.name ?? '',
    }
  }

  // ✅ Correct days calculation
  const start = new Date(leave.startDate)
  const end = new Date(leave.endDate)
  const days = Math.floor((end.getTime() - start.getTime()) / (1000*60*60*24)) + 1

  // 🔹 Use leaveTypeMap instead of switch
  type NumericLeaveKeys = 'EL' | 'CL' | 'SL' | 'unpaid' | 'compEarned' | 'compAvailed'

const key = leaveTypeMap[leave.leaveType?.name] as NumericLeaveKeys
if (key) {
  leaveGrouped[empCode][key] += days
}

})


const leaveSummaryArray = Object.values(leaveGrouped)

const attendanceMap = new Map(
  monthlyAttendance.map((a: any) => [a.employeeCode, a])
)

const combinedMonthlyData: MonthlyCombinedSummary[] =
  leaveSummaryArray.map(leave => {
    const attendance = attendanceMap.get(leave.empCode) || {}

    return {
      ...leave,
      compEarned:attendance.compEarned ?? 0,     
    compAvailed: attendance.compOffAvailed ?? 0, 

      lateDays: attendance.lateDays ?? 0,
      totalLateMinutes: attendance.totalLateMinutes ?? 0,
      earlyOutDays: attendance.earlyOutDays ?? 0,
      totalEarlyOutMinutes: attendance.totalEarlyOutMinutes ?? 0,
    }
  })

  const [month, setMonth] = useState(
  new Date().toISOString().slice(0, 7) // default current month: YYYY-MM
)

useEffect(() => {
  loadCounts()
  loadDashboardSummary()
  loadPendingApprovals()
}, [refreshTrigger, department, employeeType, month])


//   useEffect(() => {
//     console.log('🔥 useEffect fired', { department, employeeType, month })
//   loadDashboardSummary()
// }, [department, employeeType,month])


// const loadDashboardSummary = async () => {
//   try {
//     const res = await getDashboardSummary({
//       departmentId: department || undefined,
//       employmentType: employeeType || undefined,
//       month, // later dynamic
//     })

//     if (res?.statusCode === 200) {
//       const { attendanceSummary, leaveSummary } = res.data

//       // Attendance table
//       setAttendanceData(attendanceSummary)

//       // Leave summary
//       setMonthlyLeaveData(leaveSummary)
//     }
//   } catch (err) {
//     console.error('Dashboard summary error', err)
//   }
// }
// const loadDashboardSummary = async () => {
//   console.log('🔥 loadDashboardSummary CALLED')
//   try {
//     const res = await getDashboardSummary({
//       departmentId: department || undefined,
//       employmentType: employeeType || undefined,
//       month,
//     })
// console.log('FULL RESPONSE 👉', res)

     
//     if (res?.statusCode === 200) {
//       // ✅ BACKEND STRUCTURE
//       // const attendanceData =  res.data?.data?.attendance?.data ?? []
//  const rows = res.data?.data?.attendance?.data?? []

//       console.log('✅ DASHBOARD ROWS', rows)
//        const leaveData = res.data?.data?.leave?.data ?? []
//       console.log('RAW LEAVE DATA 👉', res.data?.data?.leave);

//       //  console.log('ATTENDANCE ROWS 👉', attendanceData)
     

//       // setAttendanceData(rows)
//       // setFilteredData(rows)

//       // ✅ THIS FEEDS MONTHLY SUMMARY TABLE
//       setMonthlyAttendance(rows)
//       setFilteredData(rows)
//       // setAttendanceData(attendanceData)
//       // setFilteredData(attendanceData)

//       // ✅ THIS FEEDS MONTHLY LEAVE TABLE
//       setMonthlyLeaveData(leaveData)
//     }
//   } catch (err) {
//     console.error('Dashboard summary error', err)
//     setMonthlyAttendance([])
//     setFilteredData([])
//     setMonthlyLeaveData([])
//   }
// }
const loadWorkingHoursMap = async () => {
  const { start, end } = getMonthRange(month)

  const res = await getAttendanceRecords({
    startDate: start,
    endDate: end,
    limit: 10000,
  })

  const records = res?.data?.data?.records ?? []

  const map = new Map<string, number>()

  records.forEach((r: any) => {
    if (!r.employeeCode) return
    const prev = map.get(r.employeeCode) ?? 0
    map.set(r.employeeCode, prev + toMinutes(r.duration))
  })

  return map
}

// const loadDashboardSummary = async () => {
//   console.log('🔥 loadDashboardSummary CALLED');
//   try {
//     const res = await getDashboardSummary({
//       departmentId: department || undefined,
//       employmentType: employeeType || undefined,
//       month,
//     });

//     console.log('FULL RESPONSE 👉', res);

//     // ✅ Correct path to attendance array
//     const attendanceRows = res?.data?.attendance?.data ?? [];
//     setMonthlyAttendance(attendanceRows);
//     setFilteredData(attendanceRows);

//     // ✅ Correct path to leave data
//     const leaveRows = res?.data?.leave?.data ?? [];
//     setMonthlyLeaveData(leaveRows);
//   } catch (err) {
//     console.error('Dashboard summary error', err);
//     setMonthlyAttendance([]);
//     setFilteredData([]);
//     setMonthlyLeaveData([]);
//   }
// };
const loadDashboardSummary = async () => {
  console.log('🔥 loadDashboardSummary CALLED');
  try {
    const res = await getDashboardSummary({
      departmentId: department || undefined,
      employmentType: employeeType || undefined,
      month,
    })
    console.log('FULL RESPONSE 👉', res);

    const attendanceRows = res?.data?.attendance?.data ?? []
    const leaveRows = res?.data?.leave?.data ?? []

    // 🔥 GET TOTAL WORKING HOURS
   // const durationMap = await loadWorkingHoursMap()

    const finalRows = attendanceRows.map((row: any) => ({
      ...row,
      //workingHours: toHHMM(durationMap.get(row.employeeCode) ?? 0),
    }))
console.log("FINAL ROWS 👉", attendanceRows)

    setMonthlyAttendance(finalRows)
    setFilteredData(finalRows)
    setMonthlyLeaveData(leaveRows)

  } catch (err) {
    console.error('Dashboard summary error', err)
    setMonthlyAttendance([])
    setFilteredData([])
    setMonthlyLeaveData([])
  }
}

// Reset pagination whenever filters/month change
useEffect(() => {
  setCurrentPage(1)   // Attendance table
  setCurrentPage1(1)  // Leave table
}, [department, employeeType, month])

const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10; // 10 employees per page

// Compute the slice for current page
const paginatedData = filteredData.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

const totalPages = Math.ceil(filteredData.length / itemsPerPage);

const [currentPage1, setCurrentPage1] = useState(1)
const itemsPerPage1 = 10  // can adjust this

const paginatedLeaveData = combinedMonthlyData.slice(
  (currentPage1 - 1) * itemsPerPage1,
  currentPage1 * itemsPerPage1
)

const totalLeavePages = Math.ceil(combinedMonthlyData.length / itemsPerPage1)

  return (
     <div className="container-fluid" style={{ backgroundColor: '#F4F8FD', padding: '12px' }}>
      <div className="row g-4">
      <div className="col-md-9">
      <div className="card h-100" style={{
        backgroundColor: 'transparent',
        borderRadius: '14px',
        border: 'none',
        boxShadow: 'none'
      }}>
      <div className="d-flex justify-content-between align-items-center" style={{ padding: '12px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            backgroundColor: '#EAF4FF',
            color: '#3B82F6',
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            cursor: 'pointer'
          }} onClick={refreshDashboard}>
            🔄
          </div>
          <h5 style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '16px',
            marginBottom: '0',
            cursor: 'pointer'
          }} onClick={refreshDashboard}>
            Today's Attendance
          </h5>
        </div>
        <div
          style={{
            background: '#EAF4FF',
            padding: '8px 16px',
            borderRadius: '20px',
            fontWeight: '600',
            color: '#2563EB',
            fontSize: '13px',
            border: '1px solid #D8EBFF'
          }}
        >
          Total: {counts.total}
        </div>
      </div>

      <div className="card-body" style={{ padding: '0' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#64748B' }}>Loading...</div>
        ) : (
          <div className="row g-3">
            <Metric title="Present Today" value={counts.present} color="success" />
            <Metric title="Absent Today" value={counts.absent} color="danger" />
            <Metric title="On Leave" value={counts.onLeave} color="warning" />
            <Metric title="Late Coming" value={counts.late} color="primary" />
            <Metric title="Weekly Off" value={counts.weeklyOff} color="info" />
          </div>
        )}
      </div>
    </div>
    </div>
       
  
  {/* PENDING APPROVAL BLOCK */}
      <div className="col-md-3">
        <div
          className="card h-100 text-center"
          style={{
            backgroundColor: 'transparent',
            borderRadius: '14px',
            border: 'none',
            boxShadow: 'none'
          }}
        >
          <div className="card-body d-flex flex-column justify-content-center" style={{ padding: '12px' }}>
            <div style={{
              backgroundColor: '#EAF4FF',
              color: '#3B82F6',
              width: '36px',
              height: '36px',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              margin: '0 auto 12px'
            }}>
              📋
            </div>
            <small style={{
              color: '#64748B',
              fontSize: '11px',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Leave Pending Approvals
            </small>
            <h2 style={{
              color: '#EF4444',
              fontWeight: '700',
              fontSize: '32px',
              marginTop: '8px',
              marginBottom: '4px',
              lineHeight: '1'
            }}>
              {pendingCount} 
            </h2>
            <small style={{
              color: '#64748B',
              fontSize: '11px'
            }}>
              Requires Action
            </small>
          </div>
        </div>
      </div>
      </div>
      {/* ================= EMPLOYEE VIEW CARD ================= */}
{/* <div className="col-md-4">
  <div className="card h-100">
    <div className="card-header fw-semibold">
      Employee View
    </div>

    <div className="card-body p-0">
      <table className="table table-bordered mb-0 text-center">
        <thead className="table-light">
          <tr>
            <th>Department Name</th>
            <th>No. of Employees</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Design</td>
            <td></td>
          </tr>
          <tr>
            <td>R&amp;D</td>
            <td></td>
          </tr>
          <tr>
            <td>HR</td>
            <td></td>
          </tr>
          <tr>
            <td>Admin</td>
            <td></td>
          </tr>
          <tr>
            <td>Consultants</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div> */}

<div className="card mt-4" style={{
    backgroundColor: '#FFFFFF',
    borderRadius: '14px',
    border: '1px solid #E2ECF7',
    boxShadow: 'rgba(18, 59, 115, 0.06) 0px 4px 12px'
  }}>
  <div style={{
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: '1px solid #E2ECF7',
    backgroundColor: '#FFFFFF'
  }}>
    <div style={{
      width: '4px',
      height: '32px',
      backgroundColor: '#3B82F6',
      borderRadius: '2px',
      marginRight: '16px'
    }}></div>
    <h2 style={{
      color: '#123B73',
      fontWeight: '600',
      fontSize: '16px',
      marginBottom: '0'
    }}>
      Monthly Summary by Department
    </h2>
  </div>

  <div style={{ padding: '16px' }}>
    {/* ================= FILTER ROW ================= */}
    <div className="row mb-4 g-3">
       {/* Department Dropdown */}
        <div className="col-md-3">
          <select
            className="form-select"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
          >
            <option value="">Select Department</option>
    {departments.map((dept: { id: string; name: string }) => (
      <option key={dept.id} value={dept.id}>
        {dept.name}
      </option>
))}

            
          </select>
        </div>

       {/* Employee Type Dropdown */}
        <div className="col-md-3">
  <select
    className="form-select"
    value={employeeType}
    onChange={(e) => setEmployeeType(e.target.value)}
  >
    <option value="">Select Employee Type</option>
    {employeeTypes.map((type, idx) => (
      <option key={idx} value={type}>
        {type}
      </option>
    ))}
  </select>
</div>

      
      {/* From Date */}
      {/* <div className="col-md-3">
        <input
          type="date"
          className="form-control"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
      </div> */}

      {/* To Date */}
      {/* <div className="col-md-3">
        <input
          type="date"
          className="form-control"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
      </div> */}
      {/* Month Picker */}
<div className="col-md-3">
  <input
    type="month"
    className="form-control"
    value={month}
    onChange={(e) => setMonth(e.target.value)}
  />
</div>

    </div>

   {/* ================= ATTENDANCE TABLE ================= */}
    <div className="table-responsive">
      <table className="table table-bordered" style={{
        backgroundColor: '#FFFFFF',
        borderColor: '#E2ECF7',
        borderCollapse: 'collapse',
        width: '100%'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#F4F8FD' }}>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Emp Code</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Emp Name</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Total Working Days</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Working Hours</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Present Days</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Absent Days</th>
            {/* <th>Leave Days</th> */}
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Short Hours (less than 9 hrs)</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Weekly Off</th>
          </tr>
        </thead>

        <tbody>
        {paginatedData.length > 0 ? (
          paginatedData.map((row, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #E2ECF7' }}>
              <td style={{
                padding: '10px 16px',
                color: '#123B73',
                fontWeight: '600',
                fontSize: '12px',
                verticalAlign: 'middle'
              }}>{row.employeeCode || '-'}</td>
              <td style={{
                padding: '10px 16px',
                color: '#64748B',
                fontSize: '12px',
                verticalAlign: 'middle'
              }}>{row.employeeName || '-'}</td>
              <td style={{
                padding: '10px 16px',
                color: '#64748B',
                fontSize: '12px',
                verticalAlign: 'middle'
              }}>{row.totalWorkingDays ?? '-'}</td>
              <td style={{
                padding: '10px 16px',
                color: '#64748B',
                fontSize: '12px',
                verticalAlign: 'middle'
              }}>{row.workingHours ?? '-'}</td>
              <td style={{
                padding: '10px 16px',
                color: '#64748B',
                fontSize: '12px',
                verticalAlign: 'middle'
              }}>{row.presentDays ?? '-'}</td>
              <td style={{
                padding: '10px 16px',
                color: '#64748B',
                fontSize: '12px',
                verticalAlign: 'middle'
              }}>{row.absentDays ?? '-'}</td>
              {/* <td>{row.leaveDays ?? '-'}</td> */}
              <td style={{
                padding: '10px 16px',
                color: '#64748B',
                fontSize: '12px',
                verticalAlign: 'middle'
              }}>{row.shortHours ?? '-'}</td>
              <td style={{
                padding: '10px 16px',
                color: '#64748B',
                fontSize: '12px',
                verticalAlign: 'middle'
              }}>{row.weeklyOff ?? '-'}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={8} style={{
              padding: '10px 16px',
              color: '#64748B',
              fontSize: '12px',
              textAlign: 'center'
            }}>
              No records found
            </td>
          </tr>
        )}
    </tbody>

      </table>
      {filteredData.length > 0 && (
      <div className="d-flex justify-content-between align-items-center" style={{
      padding: '10px 16px',
      borderTop: '1px solid #E2ECF7',
      backgroundColor: '#FFFFFF'
    }}>
      <span style={{
        color: '#64748B',
        fontSize: '11px'
      }}>
        {(currentPage - 1) * 10 + 1} - {Math.min(currentPage * 10, filteredData.length)} of {filteredData.length}
      </span>
      <div className="d-flex gap-1">
        <button
          disabled={currentPage === 1}
          style={{
            backgroundColor: currentPage === 1 ? '#F1F5F9' : '#FFFFFF',
            color: currentPage === 1 ? '#CBD5E1' : '#64748B',
            border: '1px solid #E2ECF7',
            padding: '4px 8px',
            borderRadius: '4px',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            fontSize: '10px',
            transition: '0.2s'
          }}
          onClick={() => setCurrentPage(prev => prev - 1)}
        >
          Prev
        </button>
        <button
          style={{
            backgroundColor: '#3B82F6',
            color: '#FFFFFF',
            border: '1px solid #E2ECF7',
            padding: '4px 8px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '10px',
            transition: '0.2s',
            minWidth: '24px'
          }}
        >
          {currentPage}
        </button>
        {totalPages > 1 && currentPage < totalPages && (
          <button
            style={{
              backgroundColor: '#FFFFFF',
              color: '#64748B',
              border: '1px solid #E2ECF7',
              padding: '4px 8px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '10px',
              transition: '0.2s',
              minWidth: '24px'
            }}
            onClick={() => setCurrentPage(prev => prev + 1)}
          >
            {currentPage + 1}
          </button>
        )}
        {totalPages > 2 && currentPage < totalPages - 1 && (
          <button
            style={{
              backgroundColor: '#FFFFFF',
              color: '#64748B',
              border: '1px solid #E2ECF7',
              padding: '4px 8px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '10px',
              transition: '0.2s',
              minWidth: '24px'
            }}
            onClick={() => setCurrentPage(totalPages)}
          >
            {totalPages}
          </button>
        )}
        <button
          disabled={currentPage === totalPages || totalPages === 0}
          style={{
            backgroundColor: currentPage === totalPages || totalPages === 0 ? '#F1F5F9' : '#FFFFFF',
            color: currentPage === totalPages || totalPages === 0 ? '#CBD5E1' : '#64748B',
            border: '1px solid #E2ECF7',
            padding: '4px 8px',
            borderRadius: '4px',
            cursor: currentPage === totalPages || totalPages === 0 ? 'not-allowed' : 'pointer',
            fontSize: '10px',
            transition: '0.2s'
          }}
          onClick={() => setCurrentPage(prev => prev + 1)}
        >
          Next
        </button>
      </div>
    </div>
      )}

    </div>

  </div>
</div>

<div className="card mt-4" style={{
    backgroundColor: '#FFFFFF',
    borderRadius: '14px',
    border: '1px solid #E2ECF7',
    boxShadow: 'rgba(18, 59, 115, 0.06) 0px 4px 12px'
  }}>
  <div style={{
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: '1px solid #E2ECF7',
    backgroundColor: '#FFFFFF'
  }}>
    <div style={{
      width: '4px',
      height: '32px',
      backgroundColor: '#D97706',
      borderRadius: '2px',
      marginRight: '16px'
    }}></div>
    <h2 style={{
      color: '#123B73',
      fontWeight: '600',
      fontSize: '16px',
      marginBottom: '0'
    }}>
      Monthly Leave Summary
    </h2>
  </div>

  <div style={{ padding: '16px' }} className="table-responsive">
  {leaveLoading ? (
    <p>Loading...</p>
  ) : (
    <table className="table table-bordered" style={{
      backgroundColor: '#FFFFFF',
      borderColor: '#E2ECF7',
      borderCollapse: 'collapse',
      width: '100%'
    }}>
      <thead>
        <tr style={{ backgroundColor: '#F4F8FD' }}>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Emp Code</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Emp Name</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>EL Taken</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>CL Taken</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>SL Taken</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Unpaid Leave</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Comp-Off Earned</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Comp-Off Availed</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Late Coming - No of Days</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Total Late Minutes</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Early Out - Total No of Days</th>
          <th style={{
            color: '#123B73',
            fontWeight: '600',
            fontSize: '12px',
            padding: '12px 16px',
            borderBottom: '1px solid #E2ECF7',
            textAlign: 'left'
          }}>Total Early Out Minutes</th>
        </tr>
      </thead>

      {/* <tbody>
        {combinedMonthlyData.length > 0 ? (
          combinedMonthlyData.map((row, index) => (
            <tr key={index}>
              <td>{row.empCode ?? '-'}</td>
              <td>{row.empName ?? '-'}</td>
              <td>{row.EL ?? 0}</td>
              <td>{row.CL ?? 0}</td>
              <td>{row.SL ?? 0}</td>
              <td>{row.unpaid ?? 0}</td>
              <td>{row.compEarned ?? 0}</td>
              <td>{row.compAvailed ?? 0}</td>
              <td>{row.lateDays ?? 0}</td>
              <td>{row.totalLateMinutes ?? 0}</td>
              <td>{row.earlyOutDays ?? 0}</td>
              <td>{row.totalEarlyOutMinutes ?? 0}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={11} className="text-center text-muted">
              No records found
            </td>
          </tr>
        )}
      </tbody> */}
      <tbody>
  {paginatedLeaveData.length > 0 ? (
    paginatedLeaveData.map((row, index) => (
      <tr key={index} style={{ borderBottom: '1px solid #E2ECF7' }}>
        <td style={{
          padding: '10px 16px',
          color: '#123B73',
          fontWeight: '600',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.empCode ?? '-'}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.empName ?? '-'}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.EL ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.CL ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.SL ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.unpaid ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.compEarned ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.compAvailed ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.lateDays ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.totalLateMinutes ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.earlyOutDays ?? 0}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{row.totalEarlyOutMinutes ?? 0}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={12} style={{
        padding: '10px 16px',
        color: '#64748B',
        fontSize: '12px',
        textAlign: 'center'
      }}>
        No records found
      </td>
    </tr>
  )}
</tbody>

    </table>
  )}
  {/* <div className="d-flex justify-content-between align-items-center mt-2">
  <button
    className="btn btn-sm btn-primary"
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(prev => prev - 1)}
  >
    Previous
  </button>

  <span>Page {currentPage} of {totalLeavePages}</span>

  <button
    className="btn btn-sm btn-primary"
    disabled={currentPage === totalLeavePages}
    onClick={() => setCurrentPage(prev => prev + 1)}
  >
    Next
  </button>
</div> */}
{monthlyLeaveData.length > 0 && (
<div className="d-flex justify-content-between align-items-center" style={{
  padding: '10px 16px',
  borderTop: '1px solid #E2ECF7',
  backgroundColor: '#FFFFFF'
}}>
  <span style={{
    color: '#64748B',
    fontSize: '11px'
  }}>
    {(currentPage1 - 1) * 10 + 1} - {Math.min(currentPage1 * 10, monthlyLeaveData.length)} of {monthlyLeaveData.length}
  </span>
  <div className="d-flex gap-1">
    <button
      disabled={currentPage1 === 1}
      style={{
        backgroundColor: currentPage1 === 1 ? '#F1F5F9' : '#FFFFFF',
        color: currentPage1 === 1 ? '#CBD5E1' : '#64748B',
        border: '1px solid #E2ECF7',
        padding: '4px 8px',
        borderRadius: '4px',
        cursor: currentPage1 === 1 ? 'not-allowed' : 'pointer',
        fontSize: '10px',
        transition: '0.2s'
      }}
      onClick={() => setCurrentPage1(prev => prev - 1)}
    >
      Prev
    </button>
    <button
      style={{
        backgroundColor: '#3B82F6',
        color: '#FFFFFF',
        border: '1px solid #E2ECF7',
        padding: '4px 8px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '10px',
        transition: '0.2s',
        minWidth: '24px'
      }}
    >
      {currentPage1}
    </button>
    {totalLeavePages > 1 && currentPage1 < totalLeavePages && (
      <button
        style={{
          backgroundColor: '#FFFFFF',
          color: '#64748B',
          border: '1px solid #E2ECF7',
          padding: '4px 8px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '10px',
          transition: '0.2s',
          minWidth: '24px'
        }}
        onClick={() => setCurrentPage1(prev => prev + 1)}
      >
        {currentPage1 + 1}
      </button>
    )}
    {totalLeavePages > 2 && currentPage1 < totalLeavePages - 1 && (
      <button
        style={{
          backgroundColor: '#FFFFFF',
          color: '#64748B',
          border: '1px solid #E2ECF7',
          padding: '4px 8px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '10px',
          transition: '0.2s',
          minWidth: '24px'
        }}
        onClick={() => setCurrentPage1(totalLeavePages)}
      >
        {totalLeavePages}
      </button>
    )}
    <button
      disabled={currentPage1 === totalLeavePages || totalLeavePages === 0}
      style={{
        backgroundColor: currentPage1 === totalLeavePages || totalLeavePages === 0 ? '#F1F5F9' : '#FFFFFF',
        color: currentPage1 === totalLeavePages || totalLeavePages === 0 ? '#CBD5E1' : '#64748B',
        border: '1px solid #E2ECF7',
        padding: '4px 8px',
        borderRadius: '4px',
        cursor: currentPage1 === totalLeavePages || totalLeavePages === 0 ? 'not-allowed' : 'pointer',
        fontSize: '10px',
        transition: '0.2s'
      }}
      onClick={() => setCurrentPage1(prev => prev + 1)}
    >
      Next
    </button>
  </div>
</div>
)}
</div>

</div>

<div className="card mt-4" style={{
    backgroundColor: '#FFFFFF',
    borderRadius: '14px',
    border: '1px solid #E2ECF7',
    boxShadow: 'rgba(18, 59, 115, 0.06) 0px 4px 12px'
  }}>
  <div style={{
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: '1px solid #E2ECF7',
    backgroundColor: '#FFFFFF'
  }}>
    <div style={{
      width: '4px',
      height: '32px',
      backgroundColor: '#EF4444',
      borderRadius: '2px',
      marginRight: '16px'
    }}></div>
    <h2 style={{
      color: '#123B73',
      fontWeight: '600',
      fontSize: '16px',
      marginBottom: '0'
    }}>
      Leave Pending Approvals
    </h2>
  </div>

  <div style={{ padding: '16px' }} className="table-responsive">
    {loadingPending ? (
      <p>Loading...</p>
    ) : pendingApprovals.length === 0 ? (
      <div role="status" className="text-center text-muted py-4">
        No pending approvals found.
      </div>
    ) : (
      <table className="table table-bordered" style={{
        backgroundColor: '#FFFFFF',
        borderColor: '#E2ECF7',
        borderCollapse: 'collapse',
        width: '100%'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#F4F8FD' }}>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>EMP Code</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Emp Name</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Request Type</th>
            <th style={{
              color: '#123B73',
              fontWeight: '600',
              fontSize: '12px',
              padding: '12px 16px',
              borderBottom: '1px solid #E2ECF7',
              textAlign: 'left'
            }}>Action</th>
          </tr>
        </thead>

        <tbody>
    {pendingApprovals.map((item: any) => (
      <tr key={item.id} style={{ borderBottom: '1px solid #E2ECF7' }}>
        <td style={{
          padding: '10px 16px',
          color: '#123B73',
          fontWeight: '600',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{item.employeeCode || '-'}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{item.employeeName || '-'}</td>
        <td style={{
          padding: '10px 16px',
          color: '#64748B',
          fontSize: '12px',
          verticalAlign: 'middle'
        }}>{item.requestType || '-'}</td>
        <td style={{
          padding: '10px 16px',
          verticalAlign: 'middle'
        }}>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => handleApproval(item.id, 'approve')}
          >
            Approve
          </button>
          <button
            className="btn btn-sm btn-danger ms-2"
            onClick={() => handleApproval(item.id, 'reject')}
          >
            Reject
          </button>
        </td>
      </tr>
    ))}
</tbody>
      </table>
    )}
  </div>
</div>


 </div>
   
    ) } 


  const Metric = ({ title, value, color }: any) => {
    const colorConfig: Record<string, { bg: string; text: string; icon: string }> = {
      success: { bg: '#E8F8F0', text: '#16A34A', icon: '✓' },
      danger: { bg: '#FDECEC', text: '#EF4444', icon: '✕' },
      warning: { bg: '#FFF5D9', text: '#D97706', icon: '⚠' },
      primary: { bg: '#EAF4FF', text: '#2563EB', icon: '⏰' },
      info: { bg: '#F0EBFF', text: '#7C3AED', icon: '📅' }
    }
    const config = colorConfig[color] || colorConfig.info
    
    return (
      <div className="col">
        <div style={{
          backgroundColor: config.bg,
          borderRadius: '10px',
          padding: '10px 12px',
          border: '1px solid ' + config.text + '20',
          boxShadow: 'rgba(18, 59, 115, 0.04) 0px 2px 4px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            marginBottom: '4px'
          }}>
            <div style={{
              backgroundColor: config.text + '15',
              color: config.text,
              width: '24px',
              height: '24px',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {config.icon}
            </div>
            <small style={{
              color: '#64748B',
              fontSize: '11px',
              fontWeight: '500'
            }}>{title}</small>
          </div>
          <h3 style={{
            color: config.text,
            fontWeight: '700',
            fontSize: '20px',
            marginBottom: '0',
            lineHeight: '1'
          }}>{value}</h3>
        </div>
      </div>
    )
  }
 
export default AttendanceDashboard

